import { defineComponent as f, computed as o, openBlock as c, createElementBlock as s, createElementVNode as t, toDisplayString as d, createCommentVNode as h, normalizeStyle as n, createStaticVNode as p } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "ff2b99cc-61ef-4581-9efb-9f800136342d" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), v = { mask: "url(#ff2b99cc-61ef-4581-9efb-9f800136342d)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#0052b4" d="M0 0h144.7l36 254.6-36 257.4H0z"></path><path fill="#d80027" d="M367.3 0H512v512H367.3l-29.7-257.3z"></path><path fill="#ffda44" d="M144.7 0h222.6v512H144.7z"></path><path fill="#d80027" d="M256 354.5V256h66.8v47.3zm-66.8-165.3H256V256h-66.8z"></path><path fill="#ff9811" d="M289.4 167a22.3 22.3 0 0 0-33.4-19.3 22.1 22.1 0 0 0-11.1-3c-12.3 0-22.3 10-22.3 22.3H167v111.3c0 41.4 32.9 65.4 58.7 77.8a22.1 22.1 0 0 0-3 11.2 22.3 22.3 0 0 0 33.3 19.3 22.1 22.1 0 0 0 11.1 3 22.3 22.3 0 0 0 19.2-33.5c25.8-12.4 58.7-36.4 58.7-77.8V167zm22.3 111.3c0 5.8 0 23.4-27.5 40.9a136.5 136.5 0 0 1-28.2 13.3c-7-2.4-17.8-6.7-28.2-13.3-27.5-17.5-27.5-35.1-27.5-41v-77.9h111.4z"></path>', 5), g = { fill: "none" }, z = ["r"], H = /* @__PURE__ */ f({
  __name: "ad",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = o(() => 512 + 2 * e.strokeWidth), a = o(() => -e.strokeWidth), r = o(() => 256 + e.strokeWidth / 2);
    return (x, w) => (c(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", v, [
        e.flagName ? (c(), s("title", k, d(e.flagName), 1)) : h("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, z)
      ])
    ], 8, _));
  }
});
export {
  H as default
};
//# sourceMappingURL=ad-7a70c1c2.js.map
